import { ChangePasswordType, ForgotPasswordType, ResetPasswordType, SignInType, SignUpType } from "@sso/types";

import { BillingAddressSignUpKeys, OrganisationSignUpKeys } from "./organisation";

export enum AuthKeys {
  ID = "id",
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  USER_NAME = "userName",
  EMAIL = "email",
  EMAIL_USER_NAME = "usernameOrEmail",
  OLD_PASSWORD = "oldPassword",
  NEW_PASSWORD = "newPassword",
  PASSWORD = "password",
  CONFIRM_PASSWORD = "confirmPassword",
}

export const signInInitialValues: SignInType = {
  [AuthKeys.EMAIL_USER_NAME]: "",
  [AuthKeys.PASSWORD]: "",
};

export const signUpInitialValues: SignUpType = {
  [AuthKeys.FIRST_NAME]: "",
  [AuthKeys.LAST_NAME]: "",
  [AuthKeys.USER_NAME]: "",
  [AuthKeys.EMAIL]: "",
  [AuthKeys.PASSWORD]: "",
  [AuthKeys.CONFIRM_PASSWORD]: "",

  [OrganisationSignUpKeys.NAME]: "",
  [OrganisationSignUpKeys.BILLING_EMAIL]: "",
  [OrganisationSignUpKeys.PHONE]: "",
  [OrganisationSignUpKeys.VAT_NUMBER]: "",
  [OrganisationSignUpKeys.ADDRESS]: {
    [BillingAddressSignUpKeys.FIRST_LINE]: "",
    [BillingAddressSignUpKeys.SECOND_LINE]: "",
    [BillingAddressSignUpKeys.CITY]: "",
    [BillingAddressSignUpKeys.STATE]: "",
    [BillingAddressSignUpKeys.POSTCODE]: "",
    [BillingAddressSignUpKeys.COUNTRY_ID]: "",
  },
};

export const forgotPasswordInitialValues: ForgotPasswordType = {
  [AuthKeys.EMAIL]: "",
};

export const resetPasswordInitialValues: ResetPasswordType = {
  [AuthKeys.PASSWORD]: "",
  [AuthKeys.CONFIRM_PASSWORD]: "",
};

export const changePasswordInitialValues: ChangePasswordType = {
  [AuthKeys.OLD_PASSWORD]: "",
  [AuthKeys.NEW_PASSWORD]: "",
  [AuthKeys.CONFIRM_PASSWORD]: "",
};
